import { of, concat, timer, interval, merge } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import { marked } from 'marked';
export function markdown(str) {
    // All links open externally
    return str ? marked(str).replace(/a href=/g, "a target='_blank' href=") : '';
}
export function throttle(func, limitMs) {
    let nextRun = 0;
    if (Date.now() < nextRun)
        return;
    nextRun += limitMs;
    func();
}
export const msToNextMinute = (timestamp) => {
    // Add a minute and chop the seconds
    const nextMinute = new Date(timestamp + 60000);
    nextMinute.setSeconds(0, 0);
    return nextMinute.getTime() - timestamp;
};
export const minuteOnMinuteInterval = () => timer(msToNextMinute(Date.now()), 60000);
function countdownParts(currentTime, targetTime) {
    let seconds = Math.ceil(Math.max(0, targetTime - currentTime) / 1000);
    const done = seconds === 0;
    const days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;
    return {
        done,
        days,
        hours,
        minutes,
        seconds
    };
}
export function countdown(endDatetime) {
    const endTime = endDatetime.getTime();
    return concat(of(0), interval(1000)).pipe(map(_ => countdownParts(Date.now(), endTime)));
}
export function countdownString(endDatetime) {
    const endTime = endDatetime.getTime();
    return concat(of(0), interval(1000)).pipe(map(_ => {
        const parts = countdownParts(Date.now(), endTime);
        if (parts.done)
            return '';
        let out = '';
        if (parts.days > 0)
            out += `${parts.days} days `;
        if (parts.hours > 0)
            out += ` ${parts.hours} hrs `;
        if (parts.hours > 0 || parts.minutes > 0)
            out += `${parts.minutes} min `;
        out += `${parts.seconds} sec`;
        return out;
    }));
}
export const coverFill = (width, height, containerWidth, containerHeight) => Math.max(containerWidth / width, containerHeight / height);
export const containFill = (width, height, containerWidth, containerHeight) => Math.min(containerWidth / width, containerHeight / height);
export function modString(str, bins) {
    let v = 0;
    for (let i = 0; i < str.length; i++) {
        v += str.charCodeAt(i);
    }
    return v % bins;
}
export function timeWindow(start, end) {
    const now = Date.now();
    const startIn = Math.max(0, start.getTime() - now);
    const endIn = end.getTime() - now;
    if (endIn <= startIn || endIn <= 0)
        return of(false);
    return concat(timer(startIn).pipe(mapTo(true)), timer(Math.max(0, endIn - startIn)).pipe(mapTo(false)));
}
export function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function groupBy(ary, key) {
    return ary.reduce((rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}
